import React, { useCallback, useEffect, useState } from "react";
import { Loading } from "src/components";
import { InfoIconEvolutive } from "src/components/Icons";
import { EVOLUTIVE_CROSSING_NETWORK_ERROR } from "src/sections/GroupCards/EvolutiveCrossChartCard/config/util/Constantes";
import useFlashMessage from "src/hooks/FlashMessage";
import { evolutiveCrossService } from "src/services/evolutiveCross";
import * as Ui from "./styles";

function CrossQuestionsAlternatives({
  // identifica que irá renderizar alternativas
  withAlternatives = true,
  // identifica que irá renderizar perguntas cruzadas
  withCrossedQuestions = true,
  // 
  listOnlyAlternatives = false,
  // id da pesquisa selecionada
  surveyId,
  // id da pergunta selecionada
  questionId,
  // id do cliente
  customerId,
  // Identifica se o item está expandido ou não
  isOpen = false,
}) {
  const [internalData, setInternalData] = useState(null);
  const [isRunning, setIsRunning] = useState(false);

  //hooks
  const [ handleFlashMessage ] = useFlashMessage();

    // renders: loading
    function renderLoadingSpinner() {
      return (
        <Ui.ItemsEmpty>
          <Loading size={30} running={isRunning} />
        </Ui.ItemsEmpty>
      );
    }

  useEffect(() => {
    if (surveyId && questionId && customerId && isOpen && !internalData) {
      setIsRunning(true);

      const endpointStrategy = listOnlyAlternatives
        ? evolutiveCrossService.fetchCrossedQuestionsAlternatives
        : evolutiveCrossService.fetchAlternativesAndCrossedQuestions;
      
      const optionalArgs = [
        ...(!listOnlyAlternatives ? [withAlternatives, withCrossedQuestions] : []),
      ];

      const resultPromise =
        endpointStrategy(
          surveyId,
          questionId,
          customerId,
          ...optionalArgs,
        );

      // on 200 status code
      resultPromise.then((result) => {
        setIsRunning(false);
        setInternalData(
          !listOnlyAlternatives
            ? { ...result.data } : [
              ...result.data
            ]
        );
      }).catch((error) => {
        const { title, message } = EVOLUTIVE_CROSSING_NETWORK_ERROR;

        setIsRunning(false);
        handleFlashMessage(
          title,
          message,
          'error'
        );
      });
    }
  }, [
    surveyId,
    questionId,
    customerId,
    withCrossedQuestions,
    withAlternatives,
    isOpen,
    internalData,
  ]);

  const renderOnlyAlternativesStrategy = useCallback(() => {
    return (
      <>
        <Ui.TitleWrapper>
          <InfoIconEvolutive />
          <Ui.Title>ALTERNATIVAS DESTA PERGUNTA</Ui.Title>
        </Ui.TitleWrapper>

        {internalData &&
          internalData.map(({ id, alternativa }) => (
            <Ui.Alternative key={id}>{alternativa}</Ui.Alternative>
        ))}
      </>
    )
  }, [internalData]);

  const defaultRenderModeStrategy = useCallback(() => {
    return (
      <>
      {withAlternatives && (
          <>
            <Ui.TitleWrapper>
              <InfoIconEvolutive />
              <Ui.Title>ALTERNATIVAS DESTA PERGUNTA</Ui.Title>
            </Ui.TitleWrapper>

            {internalData &&
              internalData.alternativas_principais?.map(({ id, enunciado }) => (
                <Ui.Alternative key={id}>{enunciado}</Ui.Alternative>
              ))}
          </>
        )}

        {withCrossedQuestions && (
          <>
            <Ui.TitleWrapper>
              <InfoIconEvolutive />
              <Ui.Title>PERGUNTAS QUE COMPÕEM ESTE CRUZAMENTO</Ui.Title>
            </Ui.TitleWrapper>

            {internalData &&
              internalData.perguntas_cruzadas.map(({ id, enunciado }) => (
                <Ui.Question key={id}>{enunciado}</Ui.Question>
              ))}
          </>
        )}
      </>
    )
  }, [internalData]);

  const renderStrategy = listOnlyAlternatives 
    ? renderOnlyAlternativesStrategy 
    : defaultRenderModeStrategy;

  return isOpen ? (
    <Ui.Container>
      <Ui.Wrapper>
        {isRunning
          ? renderLoadingSpinner()
          : renderStrategy()
        }
      </Ui.Wrapper>
    </Ui.Container>
  ) : (
    <></>
  );
}

export default React.memo(CrossQuestionsAlternatives);
